import React, { FC, ReactNode } from "react";
import {
  ImageContainer,
  Body,
  Description,
  Footer,
  Image,
  Price,
  Title,
  Wrapper,
  Tag,
} from "./styles";
import { twMerge } from "tailwind-merge";

interface CardComponentsV2 {
  ImageContainer: typeof ImageContainer;
  Body: typeof Body;
  Description: typeof Description;
  Footer: typeof Footer;
  Image: typeof Image;
  Price: typeof Price;
  Title: typeof Title;
  Tag: typeof Tag;
}

// https://travelience.atlassian.net/browse/TR-1308
export const CardV2: FC<{ className?: string; children: ReactNode }> &
  CardComponentsV2 = ({ children, className = "" }) => {
  return (
    <Wrapper
      className={twMerge(
        "bg-white rounded-md shadow w-full max-w-sm flex flex-col",
        className
      )}
    >
      {children}
    </Wrapper>
  );
};

CardV2.ImageContainer = ImageContainer;
CardV2.Body = Body;
CardV2.Description = Description;
CardV2.Footer = Footer;
CardV2.Image = Image;
CardV2.Price = Price;
CardV2.Title = Title;
CardV2.Tag = Tag;
